import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import generateExamBilet from "../../../shared/functions/generateExamBilet";
import flipCategoryTickets from "../../../shared/functions/flipCategoryTickets";

import { trainingAndThemeModeLinkSwitch } from "../../../shared/functions/trainingAndThemeModeLinkSwitch";

import "./TicketsSideBar.css";

/* import loadTicketsArray from "../../../shared/functions/loadTicketsArray";  *///function

const TicketsSideBarTabs = (props) => {

  let ticketStatusArray = JSON.parse(localStorage.getItem("ticketStatusArray"));

  function nextCategoryTicketsLink(btnName) {
    if (btnName === "AB") {
      if (
        props.categoryTickets === "ticketsCD" ||
        props.categoryTickets === "ticketsAB"
      )
        return trainingAndThemeModeLinkSwitch(ticketStatusArray, "ticketsAB");
      else if (
        props.categoryTickets === "themeAB" ||
        props.categoryTickets === "themeCD")
        return trainingAndThemeModeLinkSwitch(ticketStatusArray, "themeAB");
      else if (
        props.categoryTickets === "examAB" ||
        props.categoryTickets === "examCD"
      )
        return "/examAB/1/";
      else if (
        props.categoryTickets === "newAB" ||
        props.categoryTickets === "newCD")
        return "/newAB/1/";
      else if (props.firstTicketErrorsTicketsAB)
        return `/errorsAB/${props.firstTicketErrorsTicketsAB.ticketId}/${props.firstTicketErrorsTicketsAB.ticketErrors.sort((a, b) => a - b)[0]
          }/`;
      else return "/errorsAB/1/1/";
    } else if (btnName === "CD") {
      if (
        props.categoryTickets === "ticketsCD" ||
        props.categoryTickets === "ticketsAB"
      )
        /* return "/ticketsCD/1/1"; */
        return trainingAndThemeModeLinkSwitch(ticketStatusArray, "ticketsCD");
      else if (
        props.categoryTickets === "themeAB" ||
        props.categoryTickets === "themeCD")
        /* return "/themeCD/1/1"; */
        return trainingAndThemeModeLinkSwitch(ticketStatusArray, "themeCD");
      else if (
        props.categoryTickets === "examAB" ||
        props.categoryTickets === "examCD"
      )
        return "/examCD/1/";
      else if (
        props.categoryTickets === "newAB" ||
        props.categoryTickets === "newCD")
        return "/newCD/1/";
      else if (props.firstTicketErrorsTicketsCD)
        return `/errorsCD/${props.firstTicketErrorsTicketsCD.ticketId}/${props.firstTicketErrorsTicketsCD.ticketErrors.sort((a, b) => a - b)[0]
          }/`;
      else return "/errorsCD/1/1/";
    }
  }

  const onTabClick = async (btnName) => {
    props.setLoadedBilet(null);
    if (
      props.categoryTickets === "errorsAB" ||
      props.categoryTickets === "errorsCD"
    ) {
      let errorsArray = JSON.parse(localStorage.getItem("errorsArray"));
      if (errorsArray !== null) {
        errorsArray = errorsArray.filter((el) => el.ticketErrors.length !== 0);
        if (errorsArray.length === 0) localStorage.removeItem("errorsArray");
        else {
          localStorage.setItem("errorsArray", JSON.stringify(errorsArray));
        }
      }
    }

    if (
      props.categoryTickets.substring(
        props.categoryTickets.length - 2,
        props.categoryTickets.length
      ) !== btnName
    ) {
      props.setClickedAnswerId(null);
      props.setShouldResetTimer(true);

      if (
        props.categoryTickets === "examAB" ||
        props.categoryTickets === "examCD"
      ) {
        (async function () {
          const generatedBilet = await generateExamBilet(flipCategoryTickets(props.categoryTickets));
          props.setLoadedBilet(generatedBilet);
        })();
        props.setTicketsArray([]);
      }
      else if (props.categoryTickets === "themeAB" ||
        props.categoryTickets === "themeCD") {
        props.setTicketsArray([])
        props.setLoadedBilet(null);
      }
      else {
        props.setTicketsArray([])
        props.setLoadedBilet(null);
      }

      if (props.numbersStateArray.length !== 0) props.resetNumbersStateArray();
    }
  };

  return (
    <div className="tabs">
      <div
        onClick={() => {
          onTabClick("AB");
        }}
        className={
          "tabItem " +
          (props.categoryTickets === "ticketsAB" ||
            props.categoryTickets === "errorsAB" ||
            props.categoryTickets === "examAB" ||
            props.categoryTickets === "themeAB" ||
            props.categoryTickets === "newAB"
            ? "active-tab"
            : "non-active-tab-left")
        }
      >
        {props.categoryTickets.substring(
          props.categoryTickets.length - 2,
          props.categoryTickets.length
        ) !== "AB" ? (

          <Link className="tabs-link" to={nextCategoryTicketsLink("AB")}>
            {props.categoryTickets === "themeAB" ? "AB темы" : "AB"}
          </Link>
        ) : (
          <div className="tabs-link">  {props.categoryTickets === "themeAB" ? "AB темы" : "AB"}</div>
        )}
      </div>
      {
        props.categoryTickets !== "themeAB" &&
        <div
          onClick={() => {
            onTabClick("CD");
          }}
          className={
            "tabItem " +
            (props.categoryTickets === "ticketsCD" ||
              props.categoryTickets === "errorsCD" ||
              props.categoryTickets === "examCD" ||
              props.categoryTickets === "themeCD" ||
              props.categoryTickets === "newCD"
              ? "active-tab"
              : "non-active-tab-right")
          }
        >
          {props.categoryTickets.substring(
            props.categoryTickets.length - 2,
            props.categoryTickets.length
          ) !== "CD" ? (

            <Link className="tabs-link" to={nextCategoryTicketsLink("CD")}>
              CD
            </Link>
          ) : (
            <div className="tabs-link">CD</div>
          )}
        </div>
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    numbersStateArray: state.ticketsReducer.numbersStateArray,
    paramsTicketId: state.router.location.pathname.split("/")[2],
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({
        type: actionTypes.RESET_NUMBERS_STATE_ARRAY,
      }),
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
    setShouldResetTimer: (flag) =>
      dispatch({
        type: actionTypes.SET_SHOULD_RESET_TIMER,
        shouldResetTimer: flag,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketsSideBarTabs);
